<template>
  <v-list-item-group v-if="ratings.length > 0">
    <v-list-item v-for="rating in ratings" :key="`${rating.uuid}_${rating.id}`" @click="$emit('onSelected', rating)" class="item-bottom-border">
      <v-list-item-content>
        <v-list-item-title>
          <span class="text-subtitle-1 font-weight-medium">{{ rating.title }}</span>
          <span v-if="!isNaN(rating.grade) && rating.grade" class="caption ml-6"
            >{{ $t('bf.grade') }} <b>{{ Math.round(rating.grade * 100) / 100 }}</b></span
          >
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ rating.date }} {{ rating.time }}
          <v-icon v-if="['completedAssessments', 'completedEvaluations'].includes(type)" color="success">mdi-checkbox-marked-circle</v-icon>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn v-if="type.includes('Offline')" text outlined rounded disabled>{{ $t('bf.waitSync') }}</v-btn>
        <v-btn v-else-if="type.includes('open')" color="error" text outlined rounded>{{ $t('edit') }}</v-btn>
        <v-btn v-else-if="type.includes('completed')" text outlined rounded>{{ $t('display') }}</v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list-item-group>
</template>
<script>
export default {
  name: 'RatingsList',
  props: {
    titleKey: String,
    ratings: Array,
    type: String,
  },
};
</script>
